import sdl from '@jds/react-generated-sdl/JDSBadgeV2Notification';
import type { JDSBadgeV2NotificationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBadgeV2NotificationProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'dot',
    size = 'xtra-small',
    border = false,
    ariaLabel = 'Active Notification',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, border, ariaLabel, ...rest },
    'JDSBadgeV2Notification',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BadgeV2Notification = withLogic(
  Component
) as React.FC<JDSBadgeV2NotificationProps> & { slotName?: string };

BadgeV2Notification.displayName = 'BadgeV2Notification';
BadgeV2Notification.slotName = 'jds_badge_v_2_notification';

export { BadgeV2Notification, type JDSBadgeV2NotificationProps };
